<template lang="pug">
	.product-feed-offer-edit
		.offer-property(v-for="field in editableFields")
			.offer-property-title {{field.title}}
			textarea.offer-property-value.form-control.form-control-sm(:ref="field.property" v-if="field.control === 'textarea'" :rows="field.options.rows" @change="updateOffer(field.property, $event.target.value)" :value="offer[field.property]")
			input.offer-property-value.form-control.form-control-sm(v-else-if="field.control === 'input'" :value="offer[field.property]" @change="updateOffer(field.property, $event.target.value)")
			i.icon-revert.fa.fa-rotate-left.refresh(v-if="!offer.custom_offer" @click="resetOfferProperty(field.property)")
</template>

<script>
	import Screen 				from './../../../mixins/screen'

	import { ProductFeed } 		from './../../../services/ProductFeed'
	import {Version} 			from "./../../../services/Version";

	export default {
		name: "ProductFeedOffer",
		mixins: [Screen],
		props: ['offer', 'setting'],
		screen: {

		},
		data() {

			this.editableFields = [
				{
					title: 'Title',
					property: 'title',
					control: 'textarea',
					options: {
						rows: 3
					}
				},
				{
					title: 'Description',
					property: 'description',
					control: 'textarea',
					options: {
						rows: 10
					}
				},
				{
					title: 'Brand',
					property: 'brand',
					control: 'input'
				},
				{
					title: 'Price',
					property: 'price',
					control: 'input'
				},
				{
					title: 'URL',
					property: 'url',
					control: 'input'
				}

			];
			return {
				showed: true
			}
		},
		mounted() {

			// Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии проекта
			// this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.codename}`);

		},


		methods: {

			collectData(event, data) {

			},

			updateOffer(property, value) {

				if (!this.setting || !this.setting.value || !this.setting.value.offers || !this.offer) return;

				let offerToUpdateIndex = this.setting.value.offers.findIndex(offer => offer.offer_id === this.offer.offer_id);
				if (offerToUpdateIndex < 0) return;

				this.setting.value.offers[offerToUpdateIndex][property] = value;

				this.delaySave();

			},

			resetOfferProperty(property) {

				if (!this.setting || !this.setting.value || !this.setting.value.offers || !this.offer) return;

				let offerToUpdateIndex = this.setting.value.offers.findIndex(offer => offer.offer_id === this.offer.offer_id);
				if (offerToUpdateIndex < 0) return;

				if (ProductFeed.feedOffers && ProductFeed.feedOffers[this.offer.product_feed_id] && ProductFeed.feedOffers[this.offer.product_feed_id]) {

					this.setting.value.offers[offerToUpdateIndex][property] = ProductFeed.feedOffers[this.offer.product_feed_id][this.offer.offer_id][property];
					this.delaySave();

				} else {

					Server.sendToSocket({
						ResetSettingProductFeedOfferProperty: {
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							productFeedId: this.offer.product_feed_id,
							offerId: this.offer.offer_id,
							property: property
						}
					});

				}
			},

			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Server.sendToSocket({
						UpdateProjectVersionSetting: {
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							value: this.setting.value
						}
					});

				}, 200);

			}
		}

	}
</script>

<style lang="sass">

	.product-feed-offer-edit
		display: flex
		flex-direction: column
		padding: 5px
		gap: 5px
		border-top: 1px solid #24282c

		>.offer-property
			display: flex
			flex-direction: row

			>.offer-property-title
				min-width: 80px
				width: 80px

			>.offer-property-value
				width: 100%

			textarea.offer-property-value
				background-color: rgb(82 91 100)
				border-color: rgb(36 40 44)
				color: #e4e7ea

				&::-webkit-scrollbar
					width: 6px

				&::-webkit-scrollbar-thumb
					background-color: rgba(0, 0, 0, 0.3)

				&::-webkit-resizer
					background-color: unset

				&::-webkit-scrollbar-corner
					background-color: #3D3D3D

			>.refresh
				cursor: pointer
				width: 15px
				height: 15px
				margin-left: 5px



</style>
